import { copyText } from "@/utils/copyText";

/** Copies `text`; the caller's "Copied" snackbar opens only when the browser took it (PREC-4394). */
export const handleCopyClick = (text: string, setOpenAlert?: (open: boolean) => void) => {
	void copyText(text).then((copied) => {
		if (copied) {
			setOpenAlert?.(true);
		}
	});
};
